import { Backdrop, CircularProgress, Paper, Typography } from "@mui/material";

type LoadingBackdropProps = {
  open: boolean;
  message?: string;
};

export function LoadingBackdrop({ open, message }: LoadingBackdropProps) {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(15, 23, 42, 0.55)",
      }}
      open={open}
    >
      <Paper
        elevation={8}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: message ? 2.5 : 0,
          px: message ? 4 : 3,
          py: message ? 3.5 : 3,
          borderRadius: 2,
          minWidth: message ? 320 : undefined,
          maxWidth: 480,
        }}
      >
        <CircularProgress color="primary" size={message ? 56 : 40} thickness={4} />
        {message ? (
          <Typography
            component="p"
            sx={{
              m: 0,
              textAlign: "center",
              color: "primary.main",
              fontSize: "1.2rem",
              fontWeight: 700,
              lineHeight: 1.45,
            }}
          >
            {message}
          </Typography>
        ) : null}
      </Paper>
    </Backdrop>
  );
}
